export const ui = {
  noDataMessage: 'No data',
  unknownName: '(unknown name)',
  loading: 'Loading',
  image: {
    dropFileHere: 'Drop file here',
    uploadFile: 'Click or drag & drop',
    imageRestrictions: 'Upload .jpeg or .png, limit size: 5 MB.',
    wrongFileFormat: 'Wrong file format',
    tooLargeSize: 'File size is too large',
    noname: '(no image name)',
    mobile: {
      uploadFile: 'Click to\u00a0upload',
    },
    crop: {
      title: 'Crop avatar',
      description: 'Move and zoom your image before the signed upload starts.',
      modalTitle: 'Crop avatar',
      modalDescription:
        'Adjust the image area and zoom before uploading your avatar.',
      zoom: 'Zoom',
      cancel: 'Cancel',
      confirm: 'Confirm',
      processing: 'Processing...',
    },
  },
};
